<template>
	<div class="user-card__wrapper">
		<div class="user-card__info">
			<helio-avatar
				:user="avatarUser"
				size="x-large"
				:badge="user.personification && { position: 'top-right' }"
			/>

			<h2 class="user-card__name">
				{{ user.name }} {{ user.family_name }}
			</h2>

			<p class="user-card__email">
				{{ user.email }}
			</p>

			<helio-button
				v-if="accountSettingsLink"
				:text="$t('header.user-card.settings')"
				:link="accountSettingsLink"
				class="user-card__settings-link"
				size="small"
			/>
		</div>

		<div
			v-if="navigationLinks"
			class="user-card__dynamic-links"
		>
			<div
				v-for="(link, index) in navigationLinks"
				:key="`dynamic-link-${index}`"
				:class="[
					'user-card__dynamic-link',
					{
						'user-card__dynamic-link--active': isTheActiveUrl(link)
					},
				]"
			>
				<a
					v-if="('depersonification' in link) && user.personification"
					@click.stop="$emit('endPersonification')"
				>
					<helio-icon
						class="user-card__dynamic-link-icon"
						token="ban"
						weight="light"
					/>

					<label class="user-card__dynamic-link-name">
						{{ $t('header.user-card.end-personification') }}
					</label>
				</a>

				<a
					v-else-if="('personification' in link) && !user.personification"
					@click.stop="$emit('showPersonification')"
				>
					<helio-icon
						class="user-card__dynamic-link-icon"
						token="user-shield"
						weight="light"
					/>

					<label class="user-card__dynamic-link-name">
						{{ $t('header.user-card.personify') }}
					</label>
				</a>

				<a
					v-else-if="link.url && link.name"
					:href="link.url[$i18n.locale]"
					:target="link.target ? link.target : '_self'"
				>
					<helio-icon
						:token="link.icon"
						weight="light"
						class="user-card__dynamic-link-icon"
					/>

					<label class="user-card__dynamic-link-name">
						{{ link.name[$i18n.locale] }}
					</label>
				</a>
			</div>
		</div>

		<helio-button
			:text="$t('header.user-card.logout')"
			class="user-card__logout"
			@click.stop="$emit('logout')"
		/>
	</div>
</template>

<script>
import Avatar from '../../../avatar/Avatar.vue';
import Icon from '../../../icon/Icon.vue';
import Button from '../../../button/Button.vue';

export default {
	components: {
		'helio-avatar': Avatar,
		'helio-icon': Icon,
		'helio-button': Button,
	},

	props: {
		user: {
			type: Object,
			required: true,
		},

		navigationLinks: {
			type: Array,
			required: true,
			default: null,
		},

		accountSettingsLink: {
			type: String,
			required: false,
			default: null,
		},
	},

	data() {
		return {
			activeURL: '',
		};
	},

	computed: {
		avatarUser() {
			const avatarUser = this.cloneObject(this.user);

			if (avatarUser.name && avatarUser.family_name) {
				avatarUser.name = `${avatarUser.name} ${avatarUser.family_name}`;
			}

			return avatarUser;
		},
	},

	mounted() {
		this.setActiveUrl();
	},

	methods: {
		cleanUrl(url) {
			url = this.removeTrailingSlash(url);
			url = this.removeTrailingLocale(url);
			url = this.removeProtocol(url);
			return url;
		},

		setActiveUrl() {
			const url = window.location.href;
			const queryIndex = url.indexOf('?');
			const urlWithoutParams = queryIndex > 0 ? url.substring(0, queryIndex) : url;
			this.activeURL = this.cleanUrl(urlWithoutParams);
		},

		isTheActiveUrl(link) {
			if (this.$i18n && link.url) {
				const match = this.activeURL === this.cleanUrl(link.url[this.$i18n.locale]);
				return match;
			}

			return false;
		},
	},
};
</script>

<style lang='scss' src='./user-card-info.scss'/>
